export default function (customValues, dirName) {
  for (const val in customValues) {
    if (val.match('image-')) {
      const splittedImg = customValues[val].split(`/${dirName}/`)
      customValues[val] =
        splittedImg.length > 1 ? `${dirName}/${splittedImg[1]}` : splittedImg[0]
    }
  }

  return customValues
}
